export default __webpack_public_path__ + "static/Compass-211af6ebcc2c83c3dbf16707a1b40bac.png";